<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters(['careMode'])
  },
  watch: {
    careMode: {
      immediate: true,
      handler(val) {
        if (val) {
          document.body.classList.add('care-mode')
        } else {
          document.body.classList.remove('care-mode')
        }
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue